<label [attr.for]="inputId"
       #label>

   <input #input
          class="visually-hidden"
          [id]="inputId"
          type="checkbox"
          [required]="required"
          [checked]="checked"
          [attr.value]="value"
          [disabled]="disabled"
          [attr.name]="name"
          [attr.aria-label]="ariaLabel || null"
          [attr.aria-labelledby]="ariaLabelledby"
          [attr.aria-checked]="getAriaChecked()"
          (click)="onInputChange($event)">

   <i [class.icon-checkbox-checked]="checked"
      [class.icon-checkbox]="!checked">
   </i>

   <span class="checkbox__body">
      <ng-content></ng-content>
   </span>
</label>